import { t } from "i18next";
import { enqueueSnackbar } from "notistack";

import { apiClient } from "../../ApiClient";
import { getBackendSignatureMethod } from "../constants";
import { GetState, SetState, Store, StoreData } from "../types";

export const uploadSignedFile =
  (set: SetState<StoreData>, get: GetState<Store>) =>
  async (file: File): Promise<boolean> => {
    const integrationId = get().integrationId;
    const environment = get().environment;
    const integrationMethod = get().integrationMethod;

    if (integrationId === undefined || environment === undefined) {
      console.warn("Integration ID or environment is undefined");
      return false;
    }

    const backendMethod = getBackendSignatureMethod(integrationMethod);

    try {
      await apiClient.integrations.postIntegrationsIdAuthSignatureUploadSignedFile(integrationId, file, {
        headers: {
          "Content-Type": "application/octet-stream",
        },
        ...(backendMethod && { params: { method: backendMethod } }),
      });

      await get().initialize();
      return true;
    } catch (error) {
      enqueueSnackbar(t("error.title"));
      return false;
    }
  };
